export const GET_ALL_SUB_CATEGORY_DATA_REQUEST =
  "GET_ALL_SUB_CATEGORY_DATA_REQUEST";
export const GET_ALL_SUB_CATEGORY_DATA_SUCCESS =
  "GET_ALL_SUB_CATEGORY_DATA_SUCCESS";
export const GET_ALL_SUB_CATEGORY_DATA_FAILURE =
  "GET_ALL_SUB_CATEGORY_DATA_FAILURE";
